import { ICartComboProduct, ICartItem } from "../shared/interfaces/cart"

export function calculateActionPrice(cartItem: ICartItem) {
	let finalPrice = 0
	cartItem.products?.forEach((product: ICartComboProduct) => {
		finalPrice += product.quantity * product.price
	})

	return finalPrice
}